import React, { useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';
import { toastr } from 'react-redux-toastr';
import { PlanActions } from '../../../store/actions/plans';

import './AlertsPlan.css';
import edit from '../../Intelligence/img/edit_create.svg';
import deleteC from '../../Intelligence/img/icon_delete_create.svg';
import addPackage from '../../../assets/images/adicionar_blue.svg';
import Select from '../../Select/index';
import { isEmail } from '../../../util/utils';

const PrettoSlider = withStyles({
  root: {
    color: '#A8B1BF',
    height: 8,
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid #0d84ff',
    marginTop: -6,
    marginLeft: -10,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

function AlertsPlan(props) {
  const { company, editAlert } = props;

  const initialUseValues = 25;
  const [useValues, setUseValues] = useState(initialUseValues);
  const [alertSt, setAlertSt] = useState(company?.plan?.alerts || {});
  const [isSave, setIsSave] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [positionEdit, setPositionEdit] = useState(0);

  useEffect(() => {
    setAlertSt(company?.plan?.alerts || {});
  }, [company?.plan?.alerts]);

  const closeModal = () => {
    $('#addAlertPlan').modal('hide');
  };

  useEffect(() => {
    if (isSave) {
      alertSt.values = alertSt.values.sort();
      closeModal();
      editAlert({ companyId: company._id, alertsA: alertSt });
      setIsEdit(false);
      setIsSave(false);
    }
  }, [isSave]);

  const handleChangeUseValue = (value) => {
    setUseValues(value);
  };

  const formattedEmailsOptions = useMemo(() => {
    return alertSt && alertSt.emails
      ? alertSt.emails.map((_email) => ({
          value: _email,
          label: _email,
        }))
      : [];
  }, [alertSt]);

  const handleChangeEmail = (arrayWithNewValue) => {
    if (arrayWithNewValue) {
      const newEmails = arrayWithNewValue.map((number) => number.value);
      setAlertSt({ ...alertSt, emails: newEmails });
    } else {
      const newEmails = alertSt.contactNumbers.splice(0, 0);
      setAlertSt({ ...alertSt, emails: newEmails });
    }
  };

  const handleCreateEmailOption = (inputValue) => {
    if (isEmail(inputValue)) {
      const newEmails = alertSt.emails.concat(inputValue);
      setAlertSt({ ...alertSt, emails: newEmails });
    } else {
      toastr.error('Erro', 'O e-mail não está válido');
    }
  };

  const formattedNumberOptions = useMemo(() => {
    return alertSt && alertSt.contactNumbers
      ? alertSt.contactNumbers.map((number) => ({
          value: number,
          label: number,
        }))
      : [];
  }, [alertSt]);

  const handleChangeNumber = (arrayWithNewValue) => {
    if (arrayWithNewValue) {
      const newNumber = arrayWithNewValue.map((number) => number.value);
      setAlertSt({ ...alertSt, contactNumbers: newNumber });
    } else {
      const newNumber = alertSt.contactNumbers.splice(0, 0);
      setAlertSt({ ...alertSt, contactNumbers: newNumber });
    }
  };

  const handleCreateNumberOption = (inputValue) => {
    if (inputValue.length === 11) {
      const newNumber = alertSt.contactNumbers.concat(inputValue);
      setAlertSt({ ...alertSt, contactNumbers: newNumber });
    } else {
      toastr.error('Erro', 'O telefone está incorreto');
    }
  };

  const saveAlert = () => {
    const isValueEqual = alertSt.values.some(
      (element) => element === useValues
    );
    if (!isValueEqual) {
      if (isEdit) {
        alertSt.values[positionEdit] = useValues;
        setAlertSt({ ...alertSt, alertSt });
        setIsSave(true);
      } else {
        const newNumber = alertSt.values.concat(useValues);
        setAlertSt({ ...alertSt, values: newNumber });
        setIsSave(true);
      }
    } else {
      setIsSave(false);
      toastr.error('Erro', 'A porcentagem de uso não pode ser igual');
    }
  };

  const editAlertSt = (alert, index) => {
    setIsEdit(true);
    setUseValues(alert);
    setPositionEdit(index);
    $('#addAlertPlan').modal('show');
  };
  const deleteAlert = (alertValue) => {
    const newValue = alertSt.values.filter((header) => header !== alertValue);
    setAlertSt({ ...alertSt, values: newValue });
    setIsSave(true);
  };

  return (
    <div className="plan-container alerts-plan-container">
      <div className="header-container-alerta">
        <div className="userPlan-title" style={{ width: '100%' }}>
          Alertas de consumo de mensagens
        </div>
        <div
          className="create-package-addtional"
          data-toggle="modal"
          data-target="#addAlertPlan"
          onClick={() => setIsEdit(false)}
        >
          <img src={addPackage} alt="" />
          <span>adicionar alerta</span>
        </div>
      </div>
      <div className="body-container-alerta">
        {alertSt?.values?.map((alert, index) => (
          <div key={index} className="container-body-alert ">
            <p>{alert}%</p>
            <img src={edit} alt="" onClick={() => editAlertSt(alert, index)} />
            <img src={deleteC} alt="" onClick={() => deleteAlert(alert)} />
          </div>
        ))}
      </div>

      <div
        className="modal fade"
        id="addAlertPlan"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addAlertPlan"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ width: 445 }}>
            <div className="modal-body-alert-trava">
              <p className="title-alert-trava">Alertas de trava</p>
              <div className="container-porcentagem-uso">
                <p>
                  Porcentagem de uso: <span>{`${useValues}%`}</span>
                </p>
                <PrettoSlider
                  aria-label="pretto slider"
                  onChange={(e, value) => handleChangeUseValue(value)}
                  step={1}
                  min={0}
                  max={100}
                  name="confidence"
                  value={useValues}
                />
              </div>
              <div className="container-destinatarios">
                <p>Destinatários:</p>
                <div className="container-destinatarios-input mb-3">
                  <span>Email:</span>
                  <Select
                    value={formattedEmailsOptions}
                    onChange={(value) => handleChangeEmail(value)}
                    onCreateOption={(value) => handleCreateEmailOption(value)}
                    isCreatable
                    isMulti
                  />
                </div>
                <div className="container-destinatarios-input">
                  <span>SMS:</span>
                  <Select
                    value={formattedNumberOptions}
                    onChange={(value) => handleChangeNumber(value)}
                    onCreateOption={(value) => handleCreateNumberOption(value)}
                    isCreatable
                    isMulti
                  />
                </div>
              </div>
              <div className="container-button-save-alert-plan">
                <button onClick={saveAlert}>salvar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...PlanActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AlertsPlan)
);
